import { DICTONARY } from 'const/Dictonary';
import { useEffect } from 'react';
import adminService from 'services/admin';
import { useObtenerPasos } from 'views/ResiduoDeclarado/hooks/useObtenerPasos';

export const ResiduosDeclaradosCapaNegocio = ({
  values,
  setPasosFormulario,
  children
}) => {
  const { obtenerPasosConReglas } = useObtenerPasos();

  useEffect(() => {
    if (
      values.sucursal &&
      values.sucursal.empresa &&
      values.sucursal.empresa.roles
    ) {
      obtenerPermisos(
        values.sucursal.empresa.roles.map(item => item.codigoRol)
      );
    }
  }, [values.sucursal]);

  const obtenerPermisos = async roles => {
    try {
      const codigosRolesActuales = Array.isArray(roles) ? roles : [roles];
      const codigosPerfiles = Object.entries(DICTONARY.VALIDACION_ROLES).map(
        ([key, value]) => ({
          nombre: value.NOMBRE,
          codigo_perfil: value.CODIGO_PERFIL,
          codigo_rol: value.CODIGO
        })
      );
      const perfilEncontrado = codigosPerfiles.find(perfil =>
        codigosRolesActuales.includes(perfil.codigo_rol)
      );

      if (!perfilEncontrado) {
        throw new Error('Ningún rol tiene un perfil válido');
      }

      const codigoPerfil = perfilEncontrado.codigo_perfil;
      try {
        const response = await adminService.getPerfil(
          codigoPerfil,
          null,
          DICTONARY.INTERCEPTOR.DESACTIVADO
        );
        const permisos = response.data.permisos;
        setPasosFormulario(obtenerPasosConReglas(permisos));
      } catch (error) {
        console.log('Error al cargar los perfiles', error);
      }
    } catch (error) {
      console.log('Error al cargar los perfiles', error);
    }
  };

  return children;
};
